import React from 'react';
import { Outlet } from 'react-router-dom';
import NavBar from '../navBar/NavBar';
import './MainLayout.css';

export default function MainLayout() {
  return (
    <div className='main-layout'>
      <NavBar />
      <main className="main-content">
        <Outlet />
      </main>
    </div>
  );
}
